import { AssignmentsRequestDTO } from "src/app/model/assignments/assignments-request-dto.model";

export const DEFAULT_ASSIGNMENT_REQUEST_DTO: AssignmentsRequestDTO = {
    offset: 0,
    limit: 25,
    searchBy: '',
    userType: '',
    isSupervisorOnly: false,
    evaluatorIds: []
}
